var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { HORIZON_URL } from "../const";
var trustlineResultCache = new Map();
var trustlineInFlightCache = new Map();
var getAccountFetchErrorMessage = function (status) {
    if (status === 404) {
        return "Your Stellar account was not found. Please fund and activate your wallet first.";
    }
    if (status >= 500) {
        return "Stellar network is temporarily unavailable. Please try again.";
    }
    return "Failed to load wallet details. Please try again.";
};
export var checkTrustline = function (accountAddress_1, asset_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([accountAddress_1, asset_1], args_1, true), Promise, function (accountAddress, asset, horizonUrl) {
        var assetCode, assetIssuer, cacheKey, cachedResult, inFlightRequest, requestPromise;
        if (horizonUrl === void 0) { horizonUrl = HORIZON_URL; }
        return __generator(this, function (_a) {
            assetCode = asset.code, assetIssuer = asset.issuer;
            cacheKey = "".concat(horizonUrl, "|").concat(accountAddress, "|").concat(assetCode, "|").concat(assetIssuer);
            cachedResult = trustlineResultCache.get(cacheKey);
            if (cachedResult) {
                return [2 /*return*/, cachedResult];
            }
            inFlightRequest = trustlineInFlightCache.get(cacheKey);
            if (inFlightRequest) {
                return [2 /*return*/, inFlightRequest];
            }
            requestPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, accountData, trustline, result, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, 4, 5]);
                            return [4 /*yield*/, fetch("".concat(horizonUrl, "/accounts/").concat(accountAddress))];
                        case 1:
                            response = _a.sent();
                            if (!response.ok) {
                                throw new Error(getAccountFetchErrorMessage(response.status));
                            }
                            return [4 /*yield*/, response.json()];
                        case 2:
                            accountData = _a.sent();
                            trustline = accountData.balances.find(function (balance) {
                                // Codes of 5 to 12 characters (USDT0) are credit_alphanum12.
                                return (balance.asset_type === "credit_alphanum4" ||
                                    balance.asset_type === "credit_alphanum12") &&
                                    balance.asset_code === assetCode &&
                                    balance.asset_issuer === assetIssuer &&
                                    // A trustline the issuer has not authorized cannot receive funds.
                                    balance.is_authorized !== false;
                            });
                            result = trustline
                                ? { exists: true, balance: trustline.balance }
                                : { exists: false, balance: "0" };
                            trustlineResultCache.set(cacheKey, result);
                            return [2 /*return*/, result];
                        case 3:
                            error_1 = _a.sent();
                            throw new Error(error_1 instanceof Error ? error_1.message : "Unknown error");
                        case 4:
                            trustlineInFlightCache.delete(cacheKey);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); })();
            trustlineInFlightCache.set(cacheKey, requestPromise);
            return [2 /*return*/, requestPromise];
        });
    });
};
